






































import {Component, Prop, Mixins} from 'vue-property-decorator';
import PlanEditResultMixin from '@/mixins/plan/edit/PlanEditResultMixin';
import PlanResultEditItem from './PlanEditResultEditItem.vue';
import Draggable from 'vuedraggable';
import {PlanEditResultConfigItem} from '@/models/PlanEditResultConfigModel';
import PlanEditResultConfigComponentsEnum from '@/enums/PlanEditResultConfigComponentsEnum';
import {mapState} from 'vuex';
import PlanEditResultConfigTabTypesEnum from '@/enums/PlanEditResultConfigTabTypesEnum';

@Component({
    components: {
        PlanResultEditItem,
        Draggable,
    },
    computed: {
        ...mapState('planEditResultEdit', ['activeTabs']),
    },
})
export default class TabContentEdit extends Mixins(PlanEditResultMixin) {
    @Prop() content!: PlanEditResultConfigItem[];
    @Prop() depth!: number;

    public activeTabs!: PlanEditResultConfigTabTypesEnum[];

    get localContent() {
        return this.content;
    }
    set localContent(value: any) {
        this.$emit('update:content', value);
    }

    get actualDescriptions() {
        let alreadyHasTabsComponent: boolean = !!this.content.find(
            item => item.componentKey === PlanEditResultConfigComponentsEnum.Tabs,
        );

        return alreadyHasTabsComponent
            ? this.descriptions.filter(item => item.key !== PlanEditResultConfigComponentsEnum.Tabs)
            : this.descriptions;
    }

    onDelete(index: number) {
        this.localContent = this.localContent.filter((item: any, i: number) => i !== index);
    }

    onAdd(key: PlanEditResultConfigComponentsEnum) {
        this.localContent = [...this.localContent, this.createItem(key, this.depth + 1, this.activeTabs)];
    }
}
